export interface ITimestamp {
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  createdBy?: string | null;
  // updatedBy?: string | null;
  deletedBy?: string | null;
}
